import { styled } from 'styled-components'

import { ChallengeStatus } from '../../../types'

export const PreviewCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PreviewImage = styled.img`
  width: 100%;
  border-radius: 18px;
  height: 190px;
  object-fit: cover;
`
export const PreviewBadgesContainer = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  display: flex;
  gap: 10px;
`

export const PreviewBadge = styled.div<{
  $status: ChallengeStatus
  $visibility: boolean
}>`
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: white;
  display: flex;
  align-items: center;

  &.status {
    max-height: 19px;
    background: ${({ $status }) =>
      $status === 'active'
        ? '#22c55e'
        : $status === 'upcoming'
          ? '#01579b'
          : '#9ca3af'};
  }

  &.visibility {
    gap: 5px;
    background: ${({ $visibility }) => ($visibility ? '#0091ea' : '#9ca3af')};
    padding: 0 10px;

    svg {
      font-size: 15px;
    }
  }
`

export const TitleContainer = styled.div`
  flex-direction: row;
  display: flex;
  gap: 5px;
  align-items: center;
  width: 100%;

  svg {
    font-size: 30px;
  }
`
export const PreviewTitle = styled.h3`
  margin: 8px 0 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
`

export const PreviewMeta = styled.p`
  margin: 2px 0;
  font-size: 13px;
  color: #6b7280;
`

export const PreviewHashtags = styled.p`
  margin: 4px 0 0;
  font-size: 13px;
  color: #111827;
`
